import React, { FC, ReactNode, useCallback, useMemo } from 'react'
import { LangComponent } from 'shared/components/LangTitleBox/LangTitleBox'
import {
  BlockRoot,
  LabelLangRow,
  LabelLeft,
  FieldTitle,
  InputColumn,
  StyledTextInput,
  StyledTextarea,
  CharCount
} from './styles'

export type BilingualLangCode = 'ru' | 'en'

export type BilingualLangFieldProps = {
  label: ReactNode
  required?: boolean
  hintSlot?: ReactNode
  activeLang: BilingualLangCode
  onLangChange: (lang: BilingualLangCode) => void
  value: string
  onChange: (value: string) => void
  placeholder?: string
  maxLength?: number
  inputMode?: 'text' | 'textarea'
  charCount?: { current: number; max: number }
}

const BilingualLangField: FC<BilingualLangFieldProps> = ({
  label,
  required = false,
  hintSlot,
  activeLang,
  onLangChange,
  value,
  onChange,
  placeholder,
  maxLength,
  inputMode = 'text',
  charCount
}) => {
  const mode = inputMode === 'textarea' ? 'textarea' : 'text'
  const fieldId = useMemo(
    () =>
      `bilingual-lang-${Math.random().toString(36).slice(2, 11)}`,
    []
  )

  const toggleLang = useCallback(() => {
    onLangChange(activeLang === 'ru' ? 'en' : 'ru')
  }, [activeLang, onLangChange])

  return (
    <BlockRoot $inputMode={mode}>
      <LabelLangRow direction='row' align='center' justify='space-between'>
        <LabelLeft direction='row' align='center' gx={6}>
          <FieldTitle htmlFor={fieldId} $required={required}>
            {label}
          </FieldTitle>
          {hintSlot}
        </LabelLeft>
        <LangComponent
          lang={activeLang}
          orientation='row'
          onLangChange={toggleLang}
        />
      </LabelLangRow>
      <InputColumn>
        {mode === 'textarea' ? (
          <>
            <StyledTextarea
              id={fieldId}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              maxLength={maxLength}
              aria-required={required}
            />
            {charCount && (
              <CharCount>
                {charCount.current}/{charCount.max}
              </CharCount>
            )}
          </>
        ) : (
          <StyledTextInput
            id={fieldId}
            type='text'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-required={required}
          />
        )}
      </InputColumn>
    </BlockRoot>
  )
}

export default BilingualLangField
import React, { FC, ReactNode, useCallback, useMemo } from 'react'
import { LangComponent } from 'shared/components/LangTitleBox/LangTitleBox'
import {
  BlockRoot,
  LabelLangRow,
  LabelLeft,
  FieldTitle,
  InputColumn,
  StyledTextInput,
  StyledTextarea,
  CharCount
} from './styles'

export type BilingualLangCode = 'ru' | 'en'

export type BilingualLangFieldProps = {
  label: ReactNode
  required?: boolean
  hintSlot?: ReactNode
  activeLang: BilingualLangCode
  onLangChange: (lang: BilingualLangCode) => void
  value: string
  onChange: (value: string) => void
  placeholder?: string
  maxLength?: number
  inputMode?: 'text' | 'textarea'
  charCount?: { current: number; max: number }
}

const BilingualLangField: FC<BilingualLangFieldProps> = ({
  label,
  required = false,
  hintSlot,
  activeLang,
  onLangChange,
  value,
  onChange,
  placeholder,
  maxLength,
  inputMode = 'text',
  charCount
}) => {
  const mode = inputMode === 'textarea' ? 'textarea' : 'text'
  const fieldId = useMemo(
    () =>
      `bilingual-lang-${Math.random().toString(36).slice(2, 11)}`,
    []
  )

  const toggleLang = useCallback(() => {
    onLangChange(activeLang === 'ru' ? 'en' : 'ru')
  }, [activeLang, onLangChange])

  return (
    <BlockRoot $inputMode={mode}>
      <LabelLangRow direction='row' align='center' justify='space-between'>
        <LabelLeft direction='row' align='center' gx={6}>
          <FieldTitle htmlFor={fieldId} $required={required}>
            {label}
          </FieldTitle>
          {hintSlot}
        </LabelLeft>
        <LangComponent
          lang={activeLang}
          orientation='row'
          onLangChange={toggleLang}
        />
      </LabelLangRow>
      <InputColumn>
        {mode === 'textarea' ? (
          <>
            <StyledTextarea
              id={fieldId}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              maxLength={maxLength}
              aria-required={required}
            />
            {charCount && (
              <CharCount>
                {charCount.current}/{charCount.max}
              </CharCount>
            )}
          </>
        ) : (
          <StyledTextInput
            id={fieldId}
            type='text'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-required={required}
          />
        )}
      </InputColumn>
    </BlockRoot>
  )
}

export default BilingualLangField
